// extracted by mini-css-extract-plugin
export var description = "pricingBlock-module--description--15727";
export var featuresList = "pricingBlock-module--featuresList--1ac8a";
export var heading = "pricingBlock-module--heading--00802";
export var pricingActions = "pricingBlock-module--pricingActions--f2a56";
export var pricingCardDesktop = "pricingBlock-module--pricingCardDesktop--7a246";
export var pricingCardMobile = "pricingBlock-module--pricingCardMobile--09e51";
export var pricingSection = "pricingBlock-module--pricingSection--1a54f";
export var pricingText = "pricingBlock-module--pricingText--f95ed";